// Extract the error message from different types of exceptions
export const extractErrorMessage = (error) => {
    if(error.response){
        error = error.response;
    }
    if(error.data){
        return error.data.message.details
            ? error.data.message.details.map(({ message }) => message)
            : [error.data.message];
    }else if(error.message){
        return error.message;
    }else{
        return error;
    }
   
}


// WEBPACK FOOTER //
// ./src/Services/RequestService.js